import { Box, Grid, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import moment from 'moment';

import InlineText from '../../../Common/InlineText';
import { concatStrings, getUserById } from '../../../../utilities/common';
import { getNameFromList } from '..';

const useStyles = makeStyles((theme) => ({
  section: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  }
}))

const GRID_SPACE = 2;

function InProgressSummary(props) {
  const classes = useStyles();
  const { t } = useTranslation('incidentManagement');

  const { data, userList, isCurrentStep, statusList } = props;
  const { causedByList, rootCauseList, resultList, 
    actionResultList, correctiveActionList } = statusList;

  return (
    <Box>
      <Grid container spacing={GRID_SPACE} className={classes.section}>
        <Grid item xs={6}>
          <InlineText 
            title={t('handled_by')}
            text={getUserById(data.handler, userList)?.username || data.handler}
          />
        </Grid>
        <Grid item xs={6}>
          <InlineText 
            title={t('caused_by')}
            text={concatStrings(" - ", getNameFromList(causedByList, data.caused_by), data.caused_by_detail)}
          />
        </Grid>
        <Grid item xs={12}>
          <InlineText 
            title={t('root_cause')}
            text={concatStrings(" - ", getNameFromList(rootCauseList, data.root_cause), data.root_cause_detail)}
          />
        </Grid>
        <Grid item xs={12}>
          <InlineText 
            title={t('result_type')}
            text={concatStrings(" - ", getNameFromList(resultList, data.result_type), data.result_detail)}
          />
        </Grid>
        <Grid item xs={12}>
          <InlineText 
            title={t('remedial_corrective_action')}
            text={concatStrings(" - ", getNameFromList(correctiveActionList, data.corrective_action), data.corrective_action_detail)}
          />
        </Grid>
        {isCurrentStep ?
          <Grid item xs={12}>
            <InlineText 
              title={t('notes')}
              text={data.notes}
            />
          </Grid>: null
        }
      </Grid>
    </Box>
  )
}

export default InProgressSummary